import EmailIcon from "@mui/icons-material/Email"
import PhoneIcon from "@mui/icons-material/Phone"
import { Avatar, Card, CardActions, CardHeader } from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { Contact } from "graphql/types"

type ContactClientCardProps = {
  contact: Contact
}

export const ContactClientCard = (props: ContactClientCardProps) => {
  const { contact } = props

  const handlePhoneCall = () => {
    window.location.href = `tel:${contact.phone1}`
  }

  const handleEmail = () => {
    window.location.href = `mailto:${contact.email}`
  }

  return (
    <Card sx={{ mb: 1 }}>
      <CardHeader
        avatar={<Avatar>M</Avatar>}
        title={contact.firstName + " " + contact.lastName}
        subheader={contact.phone1 + " " + contact.email}
      />

      <CardActions>
        <StyledButton
          buttonType="custom"
          customIcon={<PhoneIcon />}
          fullWidth
          onClick={handlePhoneCall}
          variant="contained"
        >
          Anrufen
        </StyledButton>
        <StyledButton
          buttonType="custom"
          customIcon={<EmailIcon />}
          fullWidth
          onClick={handleEmail}
          variant="contained"
        >
          Email
        </StyledButton>
      </CardActions>
    </Card>
  )
}
